export const en_US = {
  shared_components: {
    common: {
      back: "Go Back",
      confirm_cancel: "Are you sure you want to cancel?",
      current_executor: "Current Assignee: ",
      filter: "Search",
      inspector: "Inspector",
      load_more: "Pull up to load more...",
      no: "No",
      organization_structure: "Organization",
      please_enter: "Please enter",
      please_select: "Please select",
      reject: "Reject",
      required_mark: "*",
      responsible_person: "Responsible Person",
      status: "Status",
      submit_date_end: "Submission Date (To)",
      submit_date_start: "Submission Date (From)",
      yes: "Yes",
      cancel: "Cancel",
      confirm: "Confirm",
      no_data: "No Data",
      delete: "Delete",
      save: "Save",
      submit: "Submit",
      map_point: "Flat icon notation",
      view_floor_plan: "View Floor Plan",
      can_multi_select: "Multiple selection",
      choose_take_photo_msg: "Photograph",
      project_cost_center_code: "Responsible Unit",
      project_name: "Responsible Organization",
      choose: "Select ",
      get_data_failed: "Failed to get data!",
      go_back_key_img: "Back",
      please_select_last_finding_category: "Please select the lowest level deviation/finding category.",
      floor_plan: "Floor Plan"
    },
    add_inspection_object: {
      inspection_obj_add: "Add inspection object",
      inspection_obj_input: "Please enter the inspection object",
      inspect_object_key: "Inspection Object",
      add_must: "Please add at least one inspection object",
      other: "Other"
    },
    corp_select: {
      please_select_last_location_for_inspection: "Please select the lowest level inspection location"
    },
    filter_modals: {
      capa_code: "CAPA No.",
      capa_exec_date: "Audit/Receipt Date",
      capa_final_verifier: "Final Verifier",
      capa_finding_desc: "Finding Description",
      capa_finding_evidence: "Finding Evidence",
      capa_finding_no: "Finding No.",
      capa_main_process: "Main Process",
      capa_person_in_charge: "Person In Charge",
      capa_source: "CAPA Source",
      capa_subject_title: "CAPA Title",
      capa_sub_process: "Sub Process",
      completion_date: "End Date",
      corrective_finished: "Corrective finished?",
      data_scope: "Data Scope",
      ehsq_number: "Evaluation ID",
      end_time: "End Date",
      end_time_not_lg_start_time: "The end time cannot be less than the start time",
      evaluation_method: "Safety KPI",
      following_field: "The following field will be generated after the task form is saved",
      from: "(From)",
      full_name: "Name",
      hazard_type: "Hazard Type",
      help_center_doc_name: "Document Name",
      immediate_check_category: "Inspection Category",
      incident_informant: "incident informant",
      inspection_level: "Inspection Hierarchy",
      job_name: "Task Being Performed",
      locations: "Location",
      poba: "Part of Body Affected",
      project_id: "Project ID",
      project_name: "Project Name",
      rate: "Rating",
      reporting_department: "Reporting Department",
      responsibility_zone: "Responsibility Zone",
      audit_reviewer: "Reviewer",
      start_time: "Start Date",
      start_time_not_lg_end_time: "The start time cannot be greater than the end time",
      supplier_id: "Contractor ID",
      target_finished: "Target finished?",
      task_code: "Task ID",
      to: "(To)",
      unsafe_behavior: "Unsafe Behavior",
      unsafe_condition: "Unsafe Condition",
      violation_item: "Finding Category",
      work_id_id: "Work ID",
      work_name: "Name of Work",
      work_related: "Work Related",
      id_number: "ID Number",
      incident_involved_person: "Person involved",
      incident_notifier_pro: "Project Manager",
      incident_reporting: "Incident Reporting",
      inspection_finding_category: "Finding Category",
      inspection_form: "Inspection Form",
      no: "No",
      project_cost_center: "Organization",
      project_name_bbs: "Responsible Organization",
      reviewer: "Reviewer",
      service_type: "Service Type",
      submit_person: "Creator",
      verification_person: "Verified By",
      yes: "Yes",
      audit_type_display_key: "Check Type",
      business_line: "Business line",
      cancel_button_key: "Cancel",
      check_table_table: "Table",
      contractor_company: "Contractor Company",
      contractor_personnel_id: "Personnel ID",
      corrective_action_title_key: "Corrective Action",
      due_date_end: "Due Date (To)",
      due_date_start: "Due Date (From)",
      end_date: "End Date",
      incident_category: "Incident Category",
      incident_location: "Incident Location",
      incident_location_range: "Location Range",
      incident_organization: "Responsible Organization",
      inspection_date_end: "Inspection Date (To)",
      inspection_date_start: "Inspection Date (From)",
      observer: "Observer",
      occupation: "Occupation",
      org_operation: "Region",
      report_date_key: "Report Date",
      report_time: "Report Time",
      reset: "Reset",
      schedule_name: "Schedule Name",
      area: "Area",
      project: "Project",
      years: "Years",
      report_start_time: "Start Date",
      report_end_time: "End Date",
      audit_type: "Audit Type",
      search_view_task_no_key: "Task Code:",
      select_upper_org_structure: "You must first select the upper-level organizational structure",
      start_date: "Start Date",
      task_type: "Inspection Type",
      work_area: "Work Area",
      work_risk_level: "Activity Risk Level",
      working_area: "Working Area",
      select_current_executor: "Select Current Executor",
      select_final_verifier: "Select Final Verifier",
      select_person_in_charge: "Select Person In Charge",
      select_reporter: "Select Reporter",
      select_reviewer: "Select Reviewer",
      select_verifier: "Select Verifier",
      incident_schedule: "Progress",
      task_name: "Task Name",
      incident_subject: "Incident Subject",
      accident_number: "accident number",
      select_capa_source: "Select CAPA Source",
      search_capa_source: "Search CAPA Source",
      select_factory: "Select Factory",
      search_factory: "Search Factory",
      search_employee: "Search Employee"
    },
    gmp_floor_plan_dialog: {
      no_area_selected: "No Area Selected Yet",
      please_mark_one_point_on_floor_plan: "Please mark one point on the floor plan",
      reset_zoom: "Reset zoom",
      selected_areas: "Selected Areas"
    },
    image_annotator_modal: {
      arrow: "↗ Arrow",
      cancel: "Cancel",
      circle: "○ Circle",
      clear: "✕ Clear",
      pen: "✏ Pen",
      pinch_zoom: "🤏 Pinch to zoom",
      rect: "□ Rect",
      save: "Save",
      text_tool: "T Text",
      title_arrow: "Arrow",
      title_circle: "Circle",
      title_pen: "Pen",
      title_rect: "Rectangle",
      title_reset_zoom: "Reset zoom",
      title_text: "Text",
      undo: "↩ Undo"
    },
    my_title: {
      homepage: "Homepage",
      enterprise_wechat_exit_home_alert: "Enterprise Wechat exit homepage"
    },
    no_source_img: {
      no_data: "No data available"
    },
    org_select_modal: {
      choose_organization_structure: "Select Organization"
    },
    popover_dialog: {
      save_local: "Temporarily saved"
    },
    return_dialog: {
      close_case: "Close",
      invalid: "Invalid"
    },
    select_picture: {
      choose_from_media_msg: "Select from the album",
      confirm_delete_msg: "Confirm deletion?",
      get_image_fail: "Failed to get picture"
    },
    select_picture_new: {
      attachement_download_fail: "Attachment download failed",
      be_uploading: "Uploading",
      cancel_key: "Cancel",
      load_from_gallery: "Load from Gallery",
      select_image_source: "Select Image Source",
      use_camera: "Use Camera",
      use_file: "Load from File",
      camera_access_denied: "Camera access denied. Please enable it in system settings.",
      camera_not_found: "No camera found on this device."
    },
    spinner: {
      data_load_msg: "Data loading, please wait..."
    },
    svg: {
      top: "top"
    },
    turn_to_send: {
      mission_assign_success: "Successful reassignment",
      report_member: "Research Team Member",
      select_mission_assignee_msg: "Please select a task transfer person!",
      turn_to_send: "Assign",
      turn_to_send_to: "Assign the task to",
      project_cost_center_code: "Project cost center code"
    },
    select_file: {
      unsupported_format_desktop_only: "This attachment format is not supported yet. Please view it on a computer.",
      format_not_supported: "This file format is not supported for online viewing. Please use the web interface to download and view it."
    },
    fabric_canvas: {
      please_select_first: "No object is selected. Please select an object first.",
      delete_current_instance_only: "Removal failed. You can only remove drawing related to this location."
    }
  }
};
